// extracted by mini-css-extract-plugin
export var content = "_o6-1";
export var fullScreen = "_o6-0";